import { useEffect, useRef, useState } from 'react';
import { DEFAULT_INSPECTOR_WIDTH } from './use-inspector-width';
import './inspector-width.css';

export function InspectorWidthHandle({ width, maximum, onReset, onChange }: {
  width: number; maximum: number; onReset: () => void; onChange: (width: number) => void;
}) {
  const drag = useRef<{ pointer: number; x: number; width: number } | null>(null);
  const [dragging, setDragging] = useState(false);
  const stop = () => { drag.current = null; setDragging(false); };
  useEffect(() => {
    if (!dragging) return;
    window.addEventListener('blur', stop);
    return () => window.removeEventListener('blur', stop);
  }, [dragging]);
  return <>
    {dragging && <div className="inspector-drag-shield" aria-hidden="true" />}
    <div className="inspector-width-handle" role="separator" tabIndex={0} aria-label="Editing controls width"
      aria-orientation="vertical" aria-controls="composing-controls" aria-valuemin={DEFAULT_INSPECTOR_WIDTH}
      aria-valuemax={maximum} aria-valuenow={width} aria-valuetext={`${width} pixels`} data-dragging={dragging}
      title="Drag to widen controls. Arrow keys adjust width; Home or double-click resets, End widens."
      onDoubleClick={onReset}
      onKeyDown={event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault(); event.stopPropagation();
        if (event.key === 'Home') onReset();
        else onChange(event.key === 'End' ? maximum : width + (event.key === 'ArrowRight' ? 1 : -1) * (event.shiftKey ? 64 : 16));
      }} onPointerDown={event => {
        if (!event.isPrimary || event.button !== 0) return;
        event.preventDefault(); event.currentTarget.focus();
        drag.current = { pointer: event.pointerId, x: event.clientX, width };
        event.currentTarget.setPointerCapture(event.pointerId); setDragging(true);
      }} onPointerMove={event => {
        const start = drag.current;
        if (start?.pointer === event.pointerId) onChange(start.width + event.clientX - start.x);
      }} onPointerUp={event => {
        if (drag.current?.pointer !== event.pointerId) return;
        stop();
        if (event.currentTarget.hasPointerCapture(event.pointerId)) event.currentTarget.releasePointerCapture(event.pointerId);
      }} onPointerCancel={stop} onLostPointerCapture={stop}>
      <span aria-hidden="true" />
    </div>
  </>;
}
